import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { APPOINTMENT_TABS } from '../constants';
import { useAppointmentAnalyticsV2ShallowStore } from '../hooks/use-appointment-analytics-v2-store';
import { AppointmentContactTypeFilter } from './filters/appointment-contact-type-filter';
import { AppointmentLocationFilter } from './filters/appointment-location-filter';
import { AppointmentProviderFilter } from './filters/appointment-provider-filter';
import { AppointmentTimePeriodFilter } from './filters/appointment-time-period-filter';
import { ViewSwitcher } from './view-switcher';

export const AppointmentAnalyticsV2Filters = () => {
  const { filters, setFilters, activeTab, setFilterHintText } = useAppointmentAnalyticsV2ShallowStore(
    'filters',
    'setFilters',
    'activeTab',
    'setFilterHintText'
  );

  const activeFilters = filters[activeTab] || {};

  const handleFilterChange = (updatedFilters: Partial<typeof activeFilters>) => {
    setFilters(updatedFilters);
  };

  return (
    <div css={styles.container}>
      <div css={styles.filtersWrapper}>
        <AppointmentLocationFilter
          value={activeFilters.locationId}
          onChange={(locationId) => handleFilterChange({ locationId })}
        />

        <AppointmentTimePeriodFilter
          activeTab={activeTab}
          upcomingDates={filters[APPOINTMENT_TABS.UPCOMING] || {}}
          pastDates={filters[APPOINTMENT_TABS.PAST] || {}}
          locationId={activeFilters.locationId}
          setFilterHintText={setFilterHintText}
          onChange={(dates) => handleFilterChange(dates)}
        />

        <AppointmentContactTypeFilter
          value={activeFilters.contactType}
          onChange={(contactType) => handleFilterChange({ contactType })}
        />

        <AppointmentProviderFilter
          locationId={activeFilters.locationId}
          value={activeFilters.provider}
          onChange={(provider) => handleFilterChange({ provider })}
        />
      </div>
      <ViewSwitcher />
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `,
  filtersWrapper: css`
    display: flex;
    gap: ${theme.spacing(2)};
    align-items: center;
  `,
};
